import React from 'react'

import { PhoneNumber as CorePhoneNumber } from '@grandvision/forms'
import { useIntl } from '@grandvision/state'

import { isPhoneNumber } from '../../../util/form-validation'

export const PhoneNumber = ({ required = false }) => {
  const { getLabel } = useIntl()

  return (
    <CorePhoneNumber
      required={required}
      validations={[isPhoneNumber]}
      label={getLabel('checkout.contact.phoneNumber')}
      errorMessage={getLabel('checkout.contact.phoneNumber.errorMessage')}
      tooltip={getLabel('checkout.contact.phoneNumber.tooltip')}
    />
  )
}
